<script>
    import { Link } from "svelte-navigator";
    import Button from "./Button.svelte";
    import IconMenu from "../assets/images/icon-menu.svelte";
    export let display_menu = true;
    export let hack = false;
    let user = null;
    let open = false;
    const handleToggle = () => {
        open = !open;
    };

    const signOut = () => {
        // not implemented
    };
</script>

<header class='header'>
    <nav class='header__nav flex flex-jc-sb flex-ai-c'>
      <div class='header__logo{hack ? '__hack' : ''}'>
        {#if hack}
          <h3>_</h3>
        {:else}
        <Link to='/'>
          <h3>FACE GARDEN</h3>
        </Link>
        {/if}        
      </div>
      {#if display_menu}
      <div class='header__menu'>
        <ul class="{!open ? 'header__list ' : 'header__list open'}">
          <!-- {#if user === null}
            <li class='header__link '>
              <Link to='/login' on:click={handleToggle}>
                <Button buttonSize='btn--large' buttonStyle='btn--solid'>
                  Log In
                </Button>
              </Link>
            </li>
          {:else}
            <li class='header__link ' on:click={signOut}>
              <Link to='//' on:click={handleToggle}>
                <Button
                  buttonSize='btn--large'
                  buttonStyle='btn--primary--solid'>
                  Log Out
                </Button>
              </Link>
            </li>
          {/if} -->

          <!-- <hr class='header__link--line' /> -->
          <Link to='/about'>
            <li class='header__link' on:click={handleToggle}>
              About
            </li>
          </Link>
          <Link to='/games' on:click={handleToggle}>
            <li class='header__link'>Games</li>
          </Link>
          <Link to='/face-expression' on:click={handleToggle}>
            <li class='header__link'>Faces</li>
          </Link>
        </ul>
      </div>
      <div
        class="{!open ? 'header__iconMenu' : 'header__iconMenu open'}"
        on:click={handleToggle}>
        <IconMenu />
      </div>
      {/if}
    </nav>
    <div
      class="{!open ? 'header__bg ' : 'header__bg open'}"
      on:click={handleToggle}
    />
  </header>